import { settingsAuditQuerySchema, auditPageSchema, defaultPlatformSettings, platformSettingsSchema, platformSettingsUpdateSchema, settingsSnapshotSchema, type SettingsSnapshot, type SettingsAuditPage, type PlatformSettings } from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";
import { M1ApiError } from "../../m1-app/data/M1AppApi";
export type { SettingsSnapshot } from "@yahshi/contracts";
export type SettingsApi = {
  get(): Promise<SettingsSnapshot>;
  update(settings: Partial<PlatformSettings>, version: number): Promise<SettingsSnapshot>;
  audit(limit?: number, offset?: number): Promise<SettingsAuditPage>;
};
export function createHttpSettingsApi(options: AdminHttpOptions): SettingsApi {
  const request = createAdminRequest(options);
  return {
    get: () => request("/admin/settings", settingsSnapshotSchema),
    update: (settings, version) => request("/admin/settings", settingsSnapshotSchema, { method: "PATCH", body: JSON.stringify(platformSettingsUpdateSchema.parse({ settings, expectedVersion: version })) }),
    audit: (limit = 50, offset = 0) => {
      const input = settingsAuditQuerySchema.parse({ limit, offset });
      return request(`/admin/settings/audit?limit=${input.limit}&offset=${input.offset}`, auditPageSchema);
    },
  };
}
export function createDevelopmentSettingsApi(): SettingsApi {
  let snapshot: SettingsSnapshot = { environment: "development", version: 0, settings: { ...defaultPlatformSettings }, updatedAt: null, updatedBy: null };
  const audits: SettingsAuditPage["items"] = [];
  return {
    async get() { return structuredClone(snapshot); },
    async update(settings, version) {
      const input = platformSettingsUpdateSchema.parse({ settings, expectedVersion: version });
      if (snapshot.version !== version) throw new M1ApiError("VERSION_CONFLICT", "设置已更新，请重新加载最新版本");
      const before = snapshot.settings;
      snapshot = { ...snapshot, version: version + 1, settings: platformSettingsSchema.parse({ ...before, ...input.settings }), updatedAt: new Date().toISOString(), updatedBy: "dev-admin" };
      audits.unshift({ id: crypto.randomUUID(), actorId: "dev-admin", action: "platform_settings.update", target: "development", requestId: null, createdAt: snapshot.updatedAt!, metadata: { before, after: snapshot.settings, version: snapshot.version } });
      return structuredClone(snapshot);
    },
    async audit(limit = 50, offset = 0) { const input = settingsAuditQuerySchema.parse({ limit, offset }); return structuredClone({ items: audits.slice(input.offset, input.offset + input.limit), total: audits.length }); },
  };
}
